export default {
    BANK: 'bank',
    BROKER: 'broker',
    TRUST_COMPANY: 'trust company',
    CREDIT_UNION: 'credit union',
};